import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../components/header";
import Footer from "../components/footer";
import Actor from "../components/Actor";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";
import "../styles/components/movieDetails.scss";
import { useParams, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

const MovieDetails = () => {
	const { id } = useParams();
	const history = useHistory();

	const API_KEY = process.env.REACT_APP_TMDB_API_KEY;
	const ytBaseUrl = "https://www.youtube.com/embed/";

	const [detail, setDetail] = useState({});
	const [genres, setGenres] = useState([]);
	const [credits, setCredits] = useState([]);
	const [bannonce, setBannonce] = useState(null);
	const [isLightboxOpen, setIsLightboxOpen] = useState(false);

	const openLightbox = () => setIsLightboxOpen(true);
	const closeLightbox = () => setIsLightboxOpen(false);

	useEffect(() => {
		if (!id) {
			return;
		}

		const URL = `https://api.themoviedb.org/3/movie/${id}?api_key=${API_KEY}&language=fr-FR`;
		const URL_CREDITS = `https://api.themoviedb.org/3/movie/${id}/credits?api_key=${API_KEY}&language=fr-FR`;
		const URL_VIDEOS = `https://api.themoviedb.org/3/movie/${id}/videos?api_key=${API_KEY}`;

		axios
			.get(URL)
			.then((res) => {
				setDetail(res.data);
				setGenres(res.data.genres);
			})
			.catch((error) => {
				console.error("Error fetching movie details:", error);
			});

		axios
			.get(URL_CREDITS)
			.then((res) => {
				setCredits(res.data.cast);
			})
			.catch((error) => {
				console.error("Error fetching credits:", error);
			});

		axios
			.get(URL_VIDEOS)
			.then((res) => {
				if (res.data.results.length > 0) {
					setBannonce(res.data.results[0]);
				}
			})
			.catch((error) => {
				console.error("Error fetching trailers:", error);
			});
	}, [id, API_KEY]);

	if (!id) {
		return <div>Invalid movie ID</div>;
	}

	const backdropUrl = `http://image.tmdb.org/t/p/original${detail.backdrop_path}`;

	/*pour formater la durée en heure et minute*/
	const formattedRuntime = detail.runtime
		? `${Math.floor(detail.runtime / 60)}h ${detail.runtime % 60}min`
		: "N/A";

	return (
		<React.Fragment>
			<Header />
			<header className="background-fiche-film">
				<div
					className="bg"
					style={{ backgroundImage: `url(${backdropUrl})` }}></div>

				<div className="detail-film">
					<div className="row">
						<div className="col-md-7 col-lg-8 col-xl-9">
							<div className="detail">
								<h1>{detail.title}</h1>
								<div className="fiche-detail  element-film">
									<div className="row">
										<div className="d-flex col-lg-6">
											<div className="pg">PG-13</div>
											<div className="fiche-date">{detail.release_date}</div>
											<div className="duree"> {formattedRuntime}</div>
										</div>
										<div className="fiche-categorie d-flex col-lg-6">
											{genres.map((g) => (
												<p
													className="type"
													key={g.id}
													onClick={() =>
														history.push("/categories", {
															id: g.id,
															name: g.name,
														})
													}>
													{g.name}
												</p>
											))}
										</div>
									</div>
								</div>
								<div>
									<div>Titre d'origine : {detail.original_title}</div>
								</div>
								<div className="fiche-evaluation">
									<svg
										version="1.1"
										width="100px"
										height="100px"
										viewBox="-10 -10 120 120">
										<path
											className="circle-bg"
											d="M0,50 A50,50,0 1 1 100,50 A50,50,0 1 1 0,50"
										/>
										<path
											className="circle"
											d="M0,50 A50,50,0 1 1 100,50 A50,50,0 1 1 0,50"
										/>
										<text
											className="percentage"
											transform="rotate(-90 50 50)"
											y="59"
											x="50">
											{Math.round(detail.vote_average * 10)} %
										</text>
									</svg>
									<div className="d-inline-flex">
										<span>Évaluation des utilisateurs</span>
										<a className="fiche-b-annonce" onClick={openLightbox}>
											Bande annonce
										</a>
									</div>
								</div>
								<div className="synopsis">
									<div>Synopsis</div>
									<p>{detail.overview}</p>
								</div>
							</div>
							{isLightboxOpen && (
								<div className="lightbox" onClick={closeLightbox}>
									<div
										className="modal-content"
										onClick={(e) => e.stopPropagation()}>
										<Link
											to="#"
											className="close-lightbox"
											onClick={closeLightbox}>
											Fermer
										</Link>
										<iframe
											title="Bande annonce"
											width="560"
											height="315"
											src={`${ytBaseUrl}${bannonce?.key}`}
											frameBorder="0"
											allowFullScreen></iframe>
									</div>
								</div>
							)}
						</div>
						<div className="d-flex justify-content-center col-md-5 col-lg-4 col-xl-3">
							<img
								className="card__image"
								src={`http://image.tmdb.org/t/p/original${detail.poster_path}`}
								alt="poster"
							/>
						</div>
					</div>
				</div>
			</header>
			<div className="fiche-film-body">
				<div className="container-fluid">
					<div className="acteurs">
						<div className="Tetes-d-affiche">
							<h2>Têtes d'affiche</h2>
						</div>
						<div className="carrousel_acteur-film">
							<div className="tendances-carrousel">
								<Splide
									options={{
										perPage: 1,
										autoplay: true,
										interval: 3500,
										rewind: true,
										speed: 2500,
										pagination: false,
										arrows: false,
										drag: true,
										updateOnMove: true,

										gap: "15px",
									}}>
									{credits.slice(0, 12).map((actor) => (
										<SplideSlide key={actor.id}>
											<Actor
												actor={actor}
												type="actor"
												onClickActor={() =>
													history.push(`/actorDetails/${actor.id}`)
												}
											/>
										</SplideSlide>
									))}
								</Splide>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</React.Fragment>
	);
};

export default MovieDetails;
